import BaseModel from "../BaseModel";

export default class RegionType extends BaseModel{
    static entity = 'regionTypes';
    static fields(){
        return {
            id: this.attr(null),
            desc: this.attr(null),
            user_id: this.attr(null)
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }
    static route(){
        return '/addresses/regions'
    }
}
